/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Reviewssubtitle1Inputs */

const he_extension_reviewssubtitle1 = /** @type {(inputs: Extension_Reviewssubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אלפי משתמשים מרוצים כבר חוסכים כסף עם PriceDrop`)
};

const en_extension_reviewssubtitle1 = /** @type {(inputs: Extension_Reviewssubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thousands of happy users already saving money with PriceDrop`)
};

/**
* | output |
* | --- |
* | "Thousands of happy users already saving money with PriceDrop" |
*
* @param {Extension_Reviewssubtitle1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_reviewssubtitle1 = /** @type {((inputs?: Extension_Reviewssubtitle1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Reviewssubtitle1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_reviewssubtitle1(inputs)
	return en_extension_reviewssubtitle1(inputs)
});
export { extension_reviewssubtitle1 as "extension_reviewsSubtitle" }